import Alert from 'antd/es/alert';

export default Alert;
